import React, { useCallback } from 'react';
import { HiOutlineCheckCircle, HiOutlineClipboardCheck } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Center,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

interface FileModalProps {
  isOpen: boolean;
  onClose: (isCancel?: boolean) => void;
  isFinal?: boolean;
  file?: string;
  total?: number;
}

export const FileModal = ({
  isOpen,
  onClose,
  isFinal = false,
  total,
  file,
}: FileModalProps) => {
  const navigate = useNavigate();

  const handleDownload = useCallback(() => {
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${file}`;
    const downloadLink = document.createElement('a');
    const fileName = 'Agendamentos.xlsx';

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }, [file]);

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent w={{ base: '80%', xs: '379px' }}>
        <ModalBody mt="40px">
          <Center w="full" display="flex" flexDir="column">
            <Icon
              p="16px"
              borderRadius="100px"
              bg="grey.200"
              w="96px"
              h="96px"
              color="ocean.100"
              as={isFinal ? HiOutlineCheckCircle : HiOutlineClipboardCheck}
            />
            <Text mt="16px" color="text.100" fontSize="24px" fontWeight={500}>
              {isFinal ? 'Concluído' : 'Sucesso!'}
            </Text>
            <Text
              textAlign="center"
              w="76%"
              mt="8px"
              aria-hidden="true"
              as="label"
              color="text.300"
            >
              {isFinal
                ? 'Solicitações de agendamento registrada com sucesso!'
                : `Os ${total} veículos foram enviados com sucesso`}
            </Text>
          </Center>

          <ModalCloseButton color="black" />
        </ModalBody>

        <ModalFooter
          mb="40px"
          gap="16px"
          flexDirection="column"
          justifyContent="center"
        >
          <Button
            disabled={!file}
            w="262px"
            onClick={() => {
              if (isFinal && file) handleDownload();
              else
                navigate('/novo-agendamento/agenda', {
                  state: { isMultiple: true },
                });
            }}
          >
            {isFinal ? 'Baixar planilha' : 'Continuar com agendamento'}
          </Button>
          <Button
            onClick={() => navigate('/agendamentos')}
            borderColor={isFinal ? 'blue.0' : 'mutable.100'}
            color={isFinal ? 'blue.0' : 'mutable.100'}
            border="1px solid"
            variant="outline"
            w="262px"
          >
            {isFinal ? 'Realizar novo agendamento' : 'Voltar para serviços'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
